export default __webpack_public_path__ + "static/media/CeciliaUreta.36f1647f.png";